import React, {
  useContext,
  useState,
  Fragment,
  Suspense,
  lazy,
  useEffect,
  useRef,
} from "react";

import { useHistory } from "react-router-dom";
import { Menu, MenuList, MenuItem } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { observer } from "mobx-react-lite";
import { playerStoreContext } from "lib/player_store";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getToken } from "lib/ajax";
import { Menu as MenuIcon } from "@material-ui/icons";
const LogInModal = lazy(() =>
  import(/* webpackChunkName: "login" */ "../modals/LogIn")
);

const SignUpModal = lazy(() =>
  import(/* webpackChunkName: "signup" */ "../modals/SignUp")
);

const useStyles = makeStyles((_theme) => ({
  paper: {
    backgroundColor: "#152f50",
    "& li": {
      color: "#fff",
      "&:hover": {
        background: "rgba(255, 255, 255, 0.1)",
      },
    },
  },
}));

const UserMenu = observer(() => {
  const store = useContext(playerStoreContext);
  const history = useHistory();
  const { user_id, logInOpen, signUpOpen } = store;

  const classes = useStyles();
  const domRef = useRef();
  const [anchorEl, setAnchorEl] = useState();
  const [menuScrolling, setMenuScrolling] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("signup") == "1") {
      store.setSignUpOpen(true);
    } else if (urlParams.get("login") == "1") {
      store.setLogInOpen(true);
    }
  }, []);

  useEffect(() => {
    if (anchorEl && domRef.current) {
      const m = domRef.current.querySelector(".MuiMenu-paper");
      if (m.scrollHeight > m.clientHeight) {
        setMenuScrolling(true);
      } else {
        setMenuScrolling(false);
      }
    }
  }, [anchorEl]);

  const setClose = () => {
    setAnchorEl(null);
    //  setState({ open: false });
  };

  const setOpen = (e) => {
    setAnchorEl(e.currentTarget);
    // setState({ open: true, anchorEl: e.currentTarget });
  };

  // const popme = () => {
  //   _jangoGuest.popme();
  // };

  // const popme_login = () => {
  //   _jangoGuest.popme_login();
  // };

  const logout = (event) => {
    var f = document.createElement("form");
    f.style.display = "none";
    document.body.appendChild(f);
    f.method = "POST";
    f.action = "/users/" + "logout";

    var m = document.createElement("input");
    m.setAttribute("type", "hidden");
    m.setAttribute("name", "_method");
    m.setAttribute("value", "delete");
    f.appendChild(m);

    var t = getToken();
    if (t) {
      var mm = document.createElement("input");
      mm.setAttribute("type", "hidden");
      mm.setAttribute("name", "authenticity_token");
      mm.setAttribute("value", t);
      f.appendChild(mm);
    }

    f.submit();
    try {
      event.stopPropagation();
    } catch (e) {}
    return false;
  };

  const nav = (value) => {
    return history.push(value);
    // return Turbo;links.visit(value);
  };

  const handleClick = (value) => (e) => {
    console.log(value)
    e?.preventDefault();
    e?.stopPropagation();

    if (value === null) {
      return;
    }
    switch (value) {
      case "logout": {
        logout();
        break;
      }
      case "signup": {
        store.setSignUpOpen(!signUpOpen);
        setAnchorEl(false);

        break;
      }
      case "login": {
        store.setLogInOpen(!logInOpen);
        setAnchorEl(false);

        break;
      }
      case "email": {
        window.open(`/users/${user_id}/emails`, "_email");

        break;
      }
      case "menuBottom": {
        document
          .querySelector("#menuBottom")
          .scrollIntoView({ behavior: "smooth", block: "nearest" });
        break;
      }
      default: {
        setAnchorEl(false);
        nav(value);
        break;
      }
    }

    return false;
  };

  // render() {
  //   const trigger = (
  //     <div
  //       style={{
  //         padding: "0px 10px",
  //         minHeight: "50px",
  //         lineHeight: "50px",
  //       }}
  //     >
  //       <Icon
  //         key="um_usercircle"
  //         name="user circle outline"
  //         className="inverted"
  //         size="large"
  //         style={{ marginRight: 0 }}
  //       />
  //       <Icon
  //         key="um_downcaret"
  //         name="down caret"
  //         className="inverted"
  //         size="small"
  //       />
  //     </div>
  //   );

  let menu_items = [];
  if (user_id > 0) {
    menu_items = menu_items.concat([
      {
        key: "fan_mail",
        text: "Artist Messages",
        value: "email",
        icon: "envelope",
      },
      {
        key: "settings",
        text: "Settings",
        value: `/users/${user_id}/account`,
        icon: "cog",
      },
      {
        key: "edit_profile",
        text: "Edit Profile",
        value: `/users/${user_id}/about`,
        icon: "edit",
      },
      {
        key: "view_profile",
        text: "View Profile",
        value: `/users/${user_id}`,
        icon: "user-circle",
      },
      {
        key: "um_logouter",
        text: "Log Out",
        value: "logout",
        icon: "sign-out-alt",
        // onClick: logout,
      },
    ]);
  } else {
    menu_items = menu_items.concat([
      {
        key: "um_signup",
        text: "Sign Up",
        value: "signup",
        // onClick: () => {
        //   store.setSignUpOpen(!signUpOpen);
        // },
      },
      {
        key: "um_login",
        text: "Log In",
        value: "login",
        // onClick: () => {
        //   store.setLogInOpen(!logInOpen);
        // },
      },
    ]);
  }

  let site_menu_items = [];
  if (user_id > 0) {
    site_menu_items = site_menu_items.concat([
      {
        key: "browse_music",
        text: "Browse Music",
        value: "/browse_music/genre/Recommended",
      },
      {
        key: "band_central",
        text: "Band Central",
        value: "/band_central/discover",
      },
      {
        key: "song_fav",
        text: "Favorite Songs",
        value: "/song_ratings/favorites",
      },
      {
        key: "my_mixes",
        text: "My Mixes",
        value: "/my_mixes",
      },
      {
        key: "station_history",
        text: "Station History",
        value: `/users/${user_id}/stations`,
      },
      {
        key: "song_history",
        text: "Song History",
        value: `/users/${user_id}/stations`,
      },

      {
        key: "song_search",
        text: "Find Songs",
        value: "/songs/search",
      },
      {
        key: "artist_search",
        text: "Find Artists",
        value: "/artists/search",
      },
      {
        key: "song_ban",
        text: "Banned Songs",
        value: "/song_ratings/bans",
      },
      // {
      //   key: "tour",
      //   text: "Site Tour",
      //   value: "tour",
      // },
    ]);
  } else {
    site_menu_items = site_menu_items.concat([
      {
        key: "browse_music",
        text: "Browse Music",
        value: "/browse_music/genre/Top Stations",
      },
      {
        key: "band_central",
        text: "Band Central",
        value: "/band_central/discover",
      },
      {
        key: "song_fav",
        text: "Favorite Songs",
        value: "/song_ratings/favorites",
      },
      { key: "my_mixes", text: "My Mixes", value: "/my_mixes" },
      {
        key: "station_history",
        text: "Station History",
        value: "/users/0/stations",
      },
      {
        key: "song_history",
        text: "Song History",
        value: "/users/0/stations",
      },

      {
        key: "song_search",
        text: "Find Songs",
        value: "/songs/search",
      },
      {
        key: "artist_search",
        text: "Find Artists",
        value: "/artists/search",
      },
      {
        key: "song_ban",
        text: "Banned Songs",
        value: "/song_ratings/bans",
      },
      // {
      //   key: "tour",
      //   text: "Site Tour",
      //   value: "tour",
      // },
    ]);
  }

  const dismissLogIn = () => {
    store.setLogInOpen(false);
  };
  const dismissSignUp = () => {
    store.setSignUpOpen(false);
  };

  return (
    <Fragment>
      {/*{user_id == 0 ? (*/}{" "}
      <MenuIcon
        fontSize="large"
        className="icon-action"
        onClick={setOpen}
        style={{ marginTop: "-6px", marginLeft: "2px" }}
      />
      {/*    ) : (
        <FontAwesomeIcon
          icon="user-circle"
          className="icon-action"
          onClick={setOpen}
        />
      )}*/}
      <Menu
        ref={domRef}
        disableScrollLock={true}
        classes={{ paper: classes.paper }}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={setClose}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MenuList>
          {menu_items.map((h) => {
            return (
              <MenuItem
                key={h.key}
                value={h.value}
                onClick={handleClick(h.value)}
              >
                {h.icon && (
                  <FontAwesomeIcon
                    size="lg"
                    icon={h.icon}
                    className="icon-action mr-2"
                    // onClick={setOpen}
                  />
                )}
                {h.text}
              </MenuItem>
            );
          })}
          <MenuItem
            value="menuBottom"
            key="scroll"
            onClick={handleClick("menuBottom")}
            className={menuScrolling ? "d-block text-center" : "d-none"}
          >
            <FontAwesomeIcon icon="angle-down" inverse size="lg" />
          </MenuItem>
          <hr className="text-white" />
          {site_menu_items.map((h) => {
            return (
              <MenuItem
                key={h.key}
                value={h.value}
                onClick={handleClick(h.value)}
              >
                {h.text}
              </MenuItem>
            );
          })}
          <div id="menuBottom"></div>
        </MenuList>
      </Menu>
      <Suspense fallback={null}>
        {user_id == 0 && logInOpen && (
          <LogInModal open={logInOpen} dismiss={dismissLogIn} />
        )}
      </Suspense>
      <Suspense fallback={null}>
        {user_id == 0 && signUpOpen && (
          <SignUpModal open={signUpOpen} dismiss={dismissSignUp} />
        )}
      </Suspense>
    </Fragment>
  );
});

export default UserMenu;
